import { Component, Inject, Input, OnDestroy, OnInit, Optional, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { StoryblokService } from '~app/modules/storyblok/services';
import { CountryCode } from '~shared/constants';
import { ProductsListUrlService } from '~app/modules/generic/services/products-list-url.service';
import { SB_CUSTOM_PLP_PAGE_ROUTE } from '~app/modules/catalog/constants';
import { StoryblokApiResponse } from '~app/modules/storyblok/models/storyblok-api-response.model';
import { Subject } from 'rxjs';
import { TitleService } from '~shared/services/title.service';
import { takeUntil } from 'rxjs/operators';
import { CommonProps } from '~app/modules/catalog/models';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { getCountryDomainCode } from '~server/utils/country-detection.util';

@Component({
  selector: 'app-custom-plp',
  templateUrl: './custom-plp.component.html',
  styleUrls: ['./custom-plp.component.scss'],
})
export class CustomPlpComponent implements OnInit, OnDestroy {
  @Input() commonProps = {} as CommonProps;

  private isBrowser: boolean = isPlatformBrowser(this.platformId);
  private unsubscribe$ = new Subject();

  storyResponse: StoryblokApiResponse;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private storyblokService: StoryblokService,
    private productsListService: ProductsListUrlService,
    private titleService: TitleService,
    @Optional() @Inject(REQUEST) private webAppBuyerRequest: any
  ) {}

  ngOnInit() {
    this.loadStoryblokData();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private setPageTitle(title: string): void {
    this.titleService.setTitle([title, { title: 'TITLE.PAGE.LANDING_PAGE' }]);
  }

  private createStoryblokContentUrl(): string {
    const market: CountryCode = getCountryDomainCode(this.webAppBuyerRequest);
    const customPlpSlug: string = this.productsListService.getCustomPlpSlug();

    return `${SB_CUSTOM_PLP_PAGE_ROUTE}/${customPlpSlug}`.replace('{market}', market);
  }

  private loadStoryblokData(): void {
    if (this.isBrowser) {
      const url: string = this.createStoryblokContentUrl();
      this.storyblokService
        .getStoryByHttp(url)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((response: StoryblokApiResponse) => {
          this.storyResponse = response;
          const { story } = response;
          this.setPageTitle(story.name);
        });
    }
  }
}
